<template>

        <Block class="skeleton"
               v-bind="$props"
               ref="outerContainer"
               :style="containerCss"
               :class="containerClass"
               v-if="! contentReady">
            <div class="skeleton-inner skeleton-inner--line"
                 v-for="n in count"
                 v-if="template === 'lines'">
                <div class="skeleton-shape  line"></div>
            </div>

            <div class="skeleton-inner skeleton-inner--line"
                 v-for="n in count"
                 v-if="template === 'thinLines'">
                <div class="skeleton-shape  line line--thin"></div>
            </div>
            <div class="skeleton-inner skeleton-inner--circle"
                 v-for="n in count"
                 v-if="template === 'circle'">
                <div class="skeleton-shape  circle" :style="circleCss"></div>
            </div>

            <div class="skeleton-inner skeleton-inner--square"
                 v-for="n in count"
                 v-if="template === 'square'">
                <div class="skeleton-shape  square" :style="squareCss"></div>
            </div>

            <div class="skeleton-inner skeleton-inner--story"
                 v-for="n in count"
                 v-if="template === 'story'">
                <div class="skeleton-story-block">
                    <div class="skeleton-shape  square" :style="squareCss"></div>
                </div>
                <div class="skeleton-story-lines">
                    <div class="skeleton-shape  line story-line-1"></div>
                    <div class="skeleton-shape  line story-line-2"></div>
                    <div class="skeleton-shape  line story-line-3"></div>
                </div>

            </div>

            <div class="skeleton-inner skeleton-inner--form"
                 v-for="n in count"
                 v-if="template === 'form'">
                <div class="skeleton-form-block">
                    <div class="skeleton-form-title line skeleton-shape"></div>
                    <div class="skeleton-form-field line skeleton-shape"></div>
                </div>
            </div>
        </Block>

        <slot v-else ></slot>


</template>

<script>
    export default {
        props: {
            fitHeight: {
                type: Boolean,
                default: true
            },
            defaultHeight: {
                type: Number,
                default: 200
            },
            template: {
                type: String,
                values: ['story','line','circle','square', 'form', 'thinLines'],
                default: 'story'
            },
            count: {
                type: Number,
                default: 1
            },
            shapeDimension: {
                type: Number,
                default: 70
            },
            contentReady : {
                type: Boolean,
                default: false,
            },
            inverse: {
                type: Boolean,
                default: false
            },
            class : {
                type : String,
                default: '',
            }
        },
        data: function () {
            return {
                mounted: false,
            };
        },
        computed: {
            height () {
                if ( ! this.mounted) {
                    return this.defaultHeight
                }

                try {
                    return this.$refs.outerContainer.$el.parentElement.offsetHeight;
                } catch (e) {
                    return this.defaultHeight
                }
            },
            containerCss () {
                return {
                    height: this.height + 'px'
                }
            },
            circleCss () {
                return {
                    height: this.shapeDimension + 'px',
                    flex: this.shapeDimension + 'px',
                    width: this.shapeDimension + 'px',
                }
            },
            squareCss () {
                return {
                    height: this.shapeDimension + 'px',
                    flex: this.shapeDimension + 'px',
                    width: this.shapeDimension + 'px',
                }
            },
            hasContent () {
                return typeof this.$slots.default === 'function';
            },
            containerClass () {
                let containerClass = this.class.split();

                containerClass.push('skeleton-wrapper')

                if (this.inverse) {
                    containerClass.push('skeleton-wrapper--inverse');
                }

                return containerClass;
            }

        },
        mounted () {
            this.mounted = true;
        }

    }
</script>

<style scoped lang="scss">

    .temp {
        min-height: 40px;
    }

    .skeleton-shape {
        display: flex;
        background: var(--global-muted-background);
        background-image: linear-gradient(to right, var(--global-muted-background) 0%, var(--global-inverse-color) 20%, var(--global-muted-background) 40%, var(--global-muted-background) 100%);
        background-repeat: no-repeat;
        background-size: 200% 100%;
        position: relative;
        -webkit-animation-duration: 1s;
        -webkit-animation-fill-mode: forwards;
        -webkit-animation-iteration-count: infinite;
        -webkit-animation-name: placeholderShimmer;
        -webkit-animation-timing-function: linear;

    }

    .skeleton-wrapper--inverse {
        .skeleton-shape {
            background: var(--global-inverse-color);
            background-image: linear-gradient(to right, var(--global-inverse-color) 0%, var(--global-color) 20%, var(--global-inverse-color) 40%, var(--global-inverse-color) 100%);
            background-repeat: no-repeat;
            background-size: 200% 100%;
            position: relative;
            -webkit-animation-duration: 1s;
            -webkit-animation-fill-mode: forwards;
            -webkit-animation-iteration-count: infinite;
            -webkit-animation-name: placeholderShimmer;
            -webkit-animation-timing-function: linear;
        }

    }

    .line {
        flex: 100%;
        height: calc(var(--global-margin) * 1.5);
        margin-bottom: calc(var(--global-margin));
    }

    .line.line--thin {
        height: calc(var(--global-margin) * 1 / 2);
        margin-bottom: calc(var(--global-margin) * 0.7 / 2);
    }


    .circle {
        display: flex;
        border-radius: 50%;
    }

    .skeleton-inner.skeleton-inner--story {
        padding: 20px;
        display: flex;

        .skeleton-story-block {
            flex: 70px;
            margin-inline-end: var(--global-margin);

        }

        .skeleton-story-lines {
            display: block;
            flex: 100%;
            width: 100%;
            flex-wrap: wrap;

            .line {
                flex: 100%;
                width: 100%;
                height: calc(var(--global-margin) * 1);
                margin-bottom: calc(var(--global-margin) * 0.7);
            }

            .story-line-1 {
                width: 70%;
            }

            .story-line-2 {
                width: 80%;
            }

            .story-line-3 {
                width: 50%;
            }
        }
    }

    .skeleton-inner--form  {
        display: block;

        .skeleton-form-block  {
            display: block;

            .line {
                display: block;
            }

            .skeleton-form-title  {
                height: 14px;
                margin-bottom: 10px;
                width: 30%;

            }
            .skeleton-form-field {
                height: 40px;
                margin-bottom: 20px;
                width: 100%;
            }
        }
    }




    @-webkit-keyframes placeholderShimmer {
        0% {
            background-position: 150% 0;
        }

        100% {
            background-position: -150% 0;
        }
    }


</style>
